import { tabAccessControl } from "../../../_helpers/access-control";

let SalesContractTabs = [
  {
    text: "All",
    path: `/sales-contract`,
    applicationFeatureCode: "CustomerSalesContract",
  },
  {
    text: "Balances",
    path: `/sales-contract-balance`,
    applicationFeatureCode: "ReportCustomerSalesContractBalance",
  },
];


 function GetIndexByTabName(tabName){
  return tabAccessControl(SalesContractTabs).findIndex((x) => x.text == tabName);
}
 
export { SalesContractTabs, GetIndexByTabName };